import React, { createContext, useContext, useState } from 'react';

// Create a context for saving state
const SavingContext = createContext();

// Context provider component
export function SavingProvider({ children }) {
  const [isSaving, setIsSaving] = useState(false);

  // Function to track saving operations
  const trackSaving = async (savingOperation) => {
    setIsSaving(true);
    try {
      const result = await savingOperation();
      return result;
    } finally {
      setIsSaving(false);
    }
  };

  // Context value
  const value = {
    isSaving,
    setIsSaving,
    trackSaving
  };

  return (
    <SavingContext.Provider value={value}>
      {children}
    </SavingContext.Provider>
  );
}

// Custom hook for using the saving context
export function useSaving() {
  const context = useContext(SavingContext);
  if (!context) {
    throw new Error('useSaving must be used within a SavingProvider');
  }
  return context;
} 